import React from 'react';
import {classes} from './HeaderLoader.st.css';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum HeaderLoaderDataHooks {
  Loader = 'HeaderDataHooks.Loader',
  OldLoader = 'HeaderDataHooks.OldLoader',
}

export const HeaderLoader = () => {
  return (
    <div className={classes.header}>
      <div className={classes.frame}>
        <SkeletonLineWrapper dataHook={HeaderLoaderDataHooks.Loader} className={classes.skeleton} />
      </div>
      <div className={classes.divider} />
    </div>
  );
};
